import React, { useCallback } from 'react'

import { RecordList, findApiV4Link, ProjectTeaserWithTracking, useJsonApi } from 'shared'
import { ProjectListApiResult, RecommenderApiResult, RecommenderProps, RenderProject } from './types'

export const Recommender = ({ apiUrl, sourceProjectId }: RecommenderProps): JSX.Element => {
  const { data: project } = useJsonApi<RecommenderApiResult>(apiUrl)
  const apiUrl2 = (project && findApiV4Link({ ofObject: project, withRel: 'recommended_projects_url' })) || ''
  const { data, loading } = useJsonApi<ProjectListApiResult>(apiUrl2)
  const recommendedProjects = (data && data.data) || []

  const renderTeaser: RenderProject = useCallback(
    (project, index) => (
      <ProjectTeaserWithTracking
        project={project}
        index={index}
        trackingPath="/project-page/recommender"
        sourceProjectID={sourceProjectId}
        openInTab
        teaserTracking="ppp-project-recommendation"
      />
    ),
    [sourceProjectId]
  )
  return (
    <div>
      <h2 className="text-3xl text-center mb-6 desktop:mb-8">{I18n.t('projects.show.recommender.headline')}</h2>
      <RecordList loading={loading} perPage={3} records={shuffle(recommendedProjects)} render={renderTeaser} />
    </div>
  )
}

const shuffle = <T,>(array: Array<T>): Array<T> => {
  for (let i = array.length; i; i--) {
    const j = Math.floor(Math.random() * i)
    ;[array[i - 1], array[j]] = [array[j], array[i - 1]]
  }
  return array
}
